import { render, staticRenderFns } from "./bookInfo.vue?vue&type=template&id=566e53ba&scoped=true&"
import script from "./bookInfo.vue?vue&type=script&lang=js&"
export * from "./bookInfo.vue?vue&type=script&lang=js&"
import style0 from "./bookInfo.vue?vue&type=style&index=0&id=566e53ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566e53ba",
  null
  
)

export default component.exports